// AustraliaPRPage.js
import React from 'react';
import PRHero from '../components/PermanentResidency/Australia/PRHero';
import WhyAustraliaPR from '../components/PermanentResidency/Australia/WhyAustraliaPR';
import PRPathways from '../components/PermanentResidency/Australia/PRPathways';
import EligibilityRequirements from '../components/PermanentResidency/Australia/EligibilityRequirements';
import ProcessTimeline from '../components/PermanentResidency/Australia/ProcessTimeline';
import PRPricing from '../components/PermanentResidency/Australia/PRPricing';
import PRFAQSection from '../components/PermanentResidency/Australia/PRFAQSection';
import PRCTASection from '../components/PermanentResidency/Australia/PRCTASection';

const AustraliaPRPage = () => {
  return (
    <div>
      <PRHero />
      <WhyAustraliaPR />
      <PRPathways />
      <EligibilityRequirements />
      <ProcessTimeline />
      <PRPricing />
      <PRFAQSection />
      <PRCTASection />
    </div>
  );
};

export default AustraliaPRPage;
